import * as React from 'react';
import { UniModalWrapper } from './UniModal';

import * as ClientHome from '../client/Home';
import * as ClientAccount from '../client/Account';

export const logout = async (e: any) => {
    if (e) {
        e.preventDefault();
    }
    await ClientHome.logout();
    location.href = '/#/login';
};
window['logout'] = logout;

interface State {
    name: string;
    accountType: string;
    superAdmin: boolean;
}

export class Nav extends React.Component<object, State> {
    constructor(props: object) {
        super(props);
        this.state = {name: '', accountType: '', superAdmin: false};
    }
    async componentDidMount () {
        const result = await ClientAccount.getAccountSelf();
        if (result.status !== 403) {
            const state = await result.json();
            this.setState({name: state.firstName, accountType: state.accountType, superAdmin: state.superAdmin});
        }
    }
    render() {
        const {accountType, superAdmin} = this.state;
        const admin = accountType === 'admin';
        const consultant = accountType === 'consultant';
        const loggedIn = accountType;
        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{paddingLeft: 0}}>
                <UniModalWrapper />
                <a className="navbar-brand" style={{fontSize: '35px'}} href={loggedIn ? '#/home' : undefined}>
                    Axceller
                    <img src="favicon.ico" style={{width: '1em', marginLeft: '0.25em', marginRight: '0.25em'}}/>
                    KorumLegal
                </a>
                {loggedIn ?
                    (
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon" />
                        </button>
                    )
                    :
                    null}
                {loggedIn ? (
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item dropdown float-right">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {this.state.name || 'Admin'}
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <a className="dropdown-item" href="#/home">Home</a>
                                        {admin ?
                                            <a className="dropdown-item" href="#/consultants">Manage Consultants</a> : null}
                                        {admin ?
                                            <a className="dropdown-item" href="#/consultants2">Consultant Report</a> : null}
                                        {admin ?
                                            <a className="dropdown-item" href="#/consultantData">Consultant Data</a> : null}
                                        {consultant ?
                                            <a className="dropdown-item" href="#/availabilityCalendar">My Availability</a> : null}
                                        {consultant ?
                                            <a className="dropdown-item" href="/#/profileVersions">My Profiles</a> : null}
                                        {consultant ?
                                            <a className="dropdown-item" href="#/selfProfile">My Account</a> : null}
                                        {admin ?
                                            <a className="dropdown-item" href="#/clients">Manage Customers</a> : null}
                                        {admin ?
                                            <a className="dropdown-item" href="#/proposals">Manage Proposals</a> : null}
                                        {admin ?
                                            <a className="dropdown-item" href="#/proposals2">Proposal Report</a> : null}
                                        {superAdmin ?
                                            <a className="dropdown-item" href="#/admins">Manage Admins</a> : null}
                                        {admin ?
                                            <a className="dropdown-item" href="#/reminders">Manage Reminders</a> : null}
                                        {superAdmin ?
                                            <a className="dropdown-item" href="#/contracts">Manage Contracts</a> : null}
                                        {consultant ?
                                            null : <a className="dropdown-item" href="#/changePassword">Change Password</a>}
                                        <a className="dropdown-item" href="#" onClick={logout}>Logout</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    ) :
                    null}
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Nav.tsx